export const rep = (colors) => Array.from({ length: 18 }, (_, i) => colors[i % colors.length]);

export const shuffle = (arr) => {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
};

const norm = (a) => Math.sqrt(a.reduce((s, x) => s + x * x, 0)) || 1;

export const createQuiz = ({ traits, bank, characters, length = 7 }) => {
  const vec = (o) => traits.map((t) => o[t] ?? 0);
  const BANK = bank.map(([q, answers]) => [q, answers.map(([text, t]) => [text, vec(t)])]);
  const CHARACTERS = characters.map((c) => ({ ...c, traits: vec(c.traits), beads: rep(c.colors) }));
  const pickQuestions = () => shuffle(BANK).slice(0, length).map(([q, answers]) => [q, shuffle(answers)]);
  const matchCharacter = (answerVectors) => {
    const total = traits.map((_, i) => answerVectors.reduce((s, a) => s + a[i], 0));
    const scored = CHARACTERS.map((c) => [c, c.traits.reduce((s, x, i) => s + x * total[i], 0) / norm(c.traits)]);
    const best = Math.max(...scored.map(([, s]) => s));
    const top = scored.filter(([, s]) => s >= best - 1e-9).map(([c]) => c);
    return top[Math.floor(Math.random() * top.length)];
  };
  return { CHARACTERS, BANK_SIZE: BANK.length, pickQuestions, matchCharacter };
};
